import ko from "knockout";
import { CustomError, customFetch as fetch } from "../../../fetch";
import { errorToast, successToast } from "../../../toastr-helper";
import { closePopups } from "../../../init";

let callbackFunction: any;

class PayrollEmployeesStatusDenyIdPopup {
    static async initializeReasonOptions(){
        denyIdModel.initializeReasonOptions()
    }
    static async submit(){
        denyIdModel.submit()
    }
    static resetValues(){
        denyIdModel.resetValues()
    }
    static fillReasonText(id: any){
        denyIdModel.fillReasonText(id)
    }
    static updateEmployeeId(id: any, reloadContracts: (selectedTab: number) => void){
        denyIdModel.employeeId(id)
        callbackFunction = reloadContracts;
    }
}

export default PayrollEmployeesStatusDenyIdPopup

class DenyIdPopupModel {
    validationErrors: KnockoutObservableArray<CustomError>;
    saving: KnockoutObservable<boolean>;
    reasonId: KnockoutObservable<string>;
    employeeId: KnockoutObservable<string>;

    reasonOptions: KnockoutObservableArray<DenyIdReasonOptionsModel>;
    reason: KnockoutObservable<string>;

    constructor() {
        this.validationErrors = ko.observableArray<CustomError>();
        this.reasonId = ko.observable<string>();
        this.employeeId = ko.observable<string>();
        this.saving = ko.observable<boolean>();

        this.reasonOptions = ko.observableArray<DenyIdReasonOptionsModel>();

        this.reason = ko.observable<string>()
            .extend({
                errorHandler: { source: this.validationErrors, id: 'DenyIdReason' }
            });

        this.initializeReasonOptions();

        this.reasonId.subscribe((id) => this.fillReasonText(id));
    }

    fillReasonText(id: any) {
        let description = this.reasonOptions().find(ro => ro.id() == id)?.description();

        if (description != null) {
            this.reason(description);
        } else {
            this.reason('');
        }
    }

    resetValues() {
        this.reasonId('');
        this.reason('');
        this.validationErrors([]);
    }

    async initializeReasonOptions() {
        const response = await fetch(`/Admin/IdTemplate/GetIdTemplates`)

        if (response.ok) {
            this.reasonOptions(response.data.map((r: any) => new DenyIdReasonOptionsModel(r)));
        } else {
            errorToast('Er ging iets mis bij het laden van de afkeur opties');
        }
    }

    async submit() {
        const fd = new FormData();
        fd.append('employeeId', this.employeeId());
        fd.append('denyIdReason', this.reason());

        this.saving(true);

        const response = await fetch(`/Admin/EmployeesRegistrationStatus/DenyId`, {
            method: 'POST',
            body: fd
        });

        if (response.ok) {
            successToast('De wijzigingen zijn opgeslagen');
            closePopups();
            callbackFunction();
        } else {
            if (response.errors && response.errors.length > 0) {
                this.validationErrors(response.errors);
            }
        }

        this.saving(false);
    }

    closePopup() {
        closePopups();
    }
}


class DenyIdReasonOptionsModel {
    id: KnockoutObservable<string>;
    name: KnockoutObservable<string>;
    description: KnockoutObservable<string>;

    constructor(model: any = {}) {
        this.id = ko.observable<string>(model.id || '');
        this.name = ko.observable<string>(model.templateTag || '');
        this.description = ko.observable<string>(model.templateDescription || '');
    }
}

const denyIdModel = new DenyIdPopupModel();
ko.applyBindings(denyIdModel, document.getElementById('denyId-file'));
